module.exports = __webpack_public_path__ + "static/img/14002007.91d1506f.png";